export default __webpack_public_path__ + "static/media/search-icon.2ee59798.svg";